<div class="card card-statistics mb-30">
  <div class="card-body">
      <h5 class="card-title">Set Annual Payroll for Year '{{inner_Year}}'</h5>
      <form [formGroup]="AddNewSalary" (submit)="SubmitAddNewSalary()">



        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Base Salary</label>
            <input formControlName="Payeh" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Payeh().valid && get_Form_Payeh().touched" class="form-text text-muted MyErrorRedColor">Enter the base salary.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Child Allowance</label>
            <input formControlName="Farzand" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Farzand().valid && get_Form_Farzand().touched" class="form-text text-muted MyErrorRedColor">Enter the child allowance.</small>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Worker Allowance</label>
            <input formControlName="BonKargari" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_BonKargari().valid && get_Form_BonKargari().touched" class="form-text text-muted MyErrorRedColor">Enter the worker allowance.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Housing Allowance</label>
            <input formControlName="Maskan" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Maskan().valid && get_Form_Maskan().touched" class="form-text text-muted MyErrorRedColor">Enter the housing allowance.</small>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Food Allowance</label>
            <input formControlName="Kharbar" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Kharbar().valid && get_Form_Kharbar().touched" class="form-text text-muted MyErrorRedColor">Enter the food allowance.</small>
          </div>
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Marital Allowance</label>
            <input formControlName="Tahahol" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Tahahol().valid && get_Form_Tahahol().touched" class="form-text text-muted MyErrorRedColor">Enter the marital allowance.</small>
          </div>
        </div>
                <div class="row">
          <div class="form-group col-md-6">
            <label for="exampleInputEmail1">Hospitality Allowance </label>
            <input formControlName="Paziraee" type="number" class="form-control"  placeholder="Type here...">
            <small *ngIf="!get_Form_Paziraee().valid && get_Form_Paziraee().touched" class="form-text text-muted MyErrorRedColor">Enter the hospitality allowance.</small>
          </div>

        </div>


        <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
        <button *ngIf="!InProccessing" type="submit" [disabled]="!AddNewSalary.valid" class="btn btn-success" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Save </button>
        <button (click)="onBack()" *ngIf="!InProccessing" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> Back </button>
      </form>
  </div>
</div>

